import AceEditor from "react-ace";
import "ace-builds/src-noconflict/mode-javascript";
import "ace-builds/src-noconflict/mode-html";
import "ace-builds/src-noconflict/mode-css";
import "ace-builds/src-noconflict/theme-monokai";
export const VerificationForm = () =>{

    function calcHeight(nbLine){
        let calc = 19*nbLine
        return calc+"px"
        }
 
    return(
    
        <div id="articleContent">
             <a class="button only" href="http://malikaleroy.fr/PROJETS/ressourcesDashboard/VerificationForm.html" target="_blank">Voir la version HTML/JS</a>
          <h2>Valider des données en Javascript au submit (version simple)</h2>
                <form method="post" action="traitement.php">
                    <label for='prenom'>Entrez votre prénom svp : </label>
                    <input type='text' name='prenom' id='prenom' maxlength='20' required />
                    <span id='missPrenom'></span><br/>
                    <label for='mail'>Entrez votre mail : </label>
                    <input type='email' name='mail' id='mail' required /><br/>
                    <label for='tel'>Numéro de téléphone :</label>
                    <input type='tel' name='tel' id='tel' required/><br/>
                    <input type='submit' value='Valider' id='submit1'/>
                </form>
                <h3>Code HTML</h3>
                <pre>
      <code>
      <AceEditor
      height={calcHeight(10)}
      width="100%"
      fontSize={16}
      showPrintMargin={false}
      showGutter={true}
      mode="html"
      theme="monokai"
      value={`<form method="post" action="traitement.php">
      <label for='prenom'>Entrez votre prénom svp : </label>
      <input type='text' name='prenom' id='prenom' maxlength='20' required />
      <span id='missPrenom'></span><br/>
      <label for='mail'>Entrez votre mail : </label>
      <input type='email' name='mail' id='mail' required /><br/>
      <label for='tel'>Numéro de téléphone :</label>
      <input type='tel' name='tel' id='tel' required/><br/>
      <input type='submit' value='Valider' id='submit1'/>
  </form>`}

        /></code></pre>
<h3>Code Javascript</h3>
<pre>
      <code>
      <AceEditor
      height={calcHeight(12)}
      width="100%"
      fontSize={16}
      showPrintMargin={false}
      showGutter={true}
      mode="javascript"
      theme="monokai"
      value={`  var formValid = document.getElementById('submit1');
      var prenom = document.getElementById('prenom');
      var missPrenom = document.getElementById('missPrenom');
      formValid.addEventListener('click', validation);
      function validation(event) {
          //Si le champ est vide
          if (prenom.validity.valueMissing) {
              event.preventDefault(); // supprimer le comportement du bouton submit par défaut
              missPrenom.textContent = 'Prénom manquant';
              missPrenom.style.color = 'red';
          }
      }`}
        /></code></pre>


                <h2>Valider des données en Javascript avec change puis submit</h2>
                <form method="post" class="defaultStyle" action="traitement.php">

                    <fieldset class="form-group opened">
                        <legend>Qui êtes-vous ?<span>Un choix est obligatoire pour ouvrir la seconde fenêtre</span>
                        </legend>
                        <div>
                            <input type="radio" name="radio" value="Particulier" id="radio1" onchange="checkRadio()" required />
                            <label for="radio1">Particulier</label><br />
                            <input type="radio" name="radio" value="Entreprise" id="radio2" onchange="checkRadio()" required />
                            <label for="radio2">Entreprise</label>
                            <div class="errorMessage"></div>
                        </div>
                        <div>
                            <input type="checkbox" id="newsletter" name="newsletter"/>
                            <label for="newsletter">Inscription à une newsletter</label>
                        </div>
                        <div>
                            <input type="checkbox" id="rgpd" name="rgpd" required onchange="checkBox()" />
                            <label for="rgpd">J'accepte les conditions</label>
                        </div>

                        <div class="js-mandatory">
                            <input type="checkbox" id="2choices1" name="2choices" onchange="checkBox(2)"/>
                            <label for="2choices1">Element 1</label>
                            <input type="checkbox" id="2choices2" name="2choices" onchange="checkBox(2)"/>
                            <label for="2choices2">Element 2</label>
                            <input type="checkbox" id="2choices3" name="2choices" onchange="checkBox(2)"/>
                            <label for="2choices3">Element 3</label>
                        </div>
                        <div>
                            <label for="pet-select">Choisir un animal:</label>
                            <select name="pets" id="pet-select" onchange="checkRadio()" required>
                                <option value="">--Please choose an option--</option>
                                <option value="dog">Dog</option>
                                <option value="cat">Cat</option>
                                <option value="hamster">Hamster</option>
                                <option value="parrot">Parrot</option>
                                <option value="spider">Spider</option>
                                <option value="goldfish">Goldfish</option>
                            </select>
                         </div>
                         <div>
                        <label for="start">Choisir une date après la date actuel:</label>
                         <input type="date" id="start" name="trip-start" onchange="checkDate()" required/>
                         <div class="errorMessage"></div>
                         </div>
                         <div>
                            <label for="volume">Volume</label>
                            <input type="range" id="volume" name="volume" onchange="checkRange(50)" required/>
                            <div class="errorMessage"></div>
                          </div>



                        <input type="button" value="Passer à l'étape suivante" class="buttonStep" onclick="nextStep()" disabled/>
                    </fieldset>

                    <fieldset class="form-group closed">
                        <legend>Informations personnelles</legend>
                        
                        <div>
                            <label for="lambda">Champ optionnel </label> :
                            <input type="text" id="lambda" oninput="checkInput(regexOptionnalMandatoryOnLine)" />
                            <div class="errorMessage"></div>
                        </div>

                        <div>
                            <label for="textarea"> Textarea </label> :
                            <textarea type="text" id="textarea" oninput="checkInput(regexOptionnalMandatoryOnLine)" required>Texte d'exemple</textarea>
                            <div class="errorMessage"></div>
                        </div>


                        <div>
                            <label for="name">Nom (no length)</label>* :
                            <input type="text" id="name" required oninput="checkInput(regexName)" />
                            <div class="errorMessage"></div>
                        </div>
                        <div>
                            <label for="codePost">Code postal français (length mandatory)</label>* :
                            <input type="text" id="codePost" required oninput="checkInput(regexNumber,messageFormatPostCode,'',5,'')" />
                            <div class="errorMessage"></div>
                        </div>

                        
                        <div>
                            <label for="password">Mot de passe (length min)</label>* :
                            <input type="password" id="password" required oninput="checkInput(regexPassword,messageFormatPassword,6,'','')" />
                            <div class="errorMessage"></div>
                        </div>

                        <div>
                            <label for="phone">téléphone (length max)</label>* :
                            <input type="text" id="phone" required oninput="checkInput(regexPhoneInternationalAndFrench,messageFormatPhone,'','','15')" />
                            <div class="errorMessage"></div>
                        </div>


                            <input type="button" value="Passer à l'étape suivante" class="buttonStep" onclick="nextStep()" disabled/>
                    </fieldset>
                    <input type='submit' value='Valider' id='submit2'></input>
</form>

                   

<h3>Code HTML</h3>
  
      <pre>
      <code>
      <AceEditor
      height={calcHeight(89)}
      width="100%"
      fontSize={16}
      showPrintMargin={false}
      showGutter={true}
      mode="html"
      theme="monokai"
      value={`<form method="post" class="defaultStyle" action="traitement.php">
      <fieldset class="form-group opened">
          <legend>Qui êtes-vous ?<span>Un choix est obligatoire pour ouvrir la seconde fenêtre</span>
          </legend>
          <div>
              <input type="radio" name="radio" value="Particulier" id="radio1" onchange="checkRadio()" required />
              <label for="radio1">Particulier</label><br />
              <input type="radio" name="radio" value="Entreprise" id="radio2" onchange="checkRadio()" required />
              <label for="radio2">Entreprise</label>
              <div class="errorMessage"></div>
          </div>
          <div>
              <input type="checkbox" id="newsletter" name="newsletter"/>
              <label for="newsletter">Inscription à une newsletter</label>
          </div>
          <div>
              <input type="checkbox" id="rgpd" name="rgpd" required onchange="checkBox()" />
              <label for="rgpd">J'accepte les conditions</label>
          </div>

          <div class="js-mandatory">
              <input type="checkbox" id="2choices1" name="2choices" onchange="checkBox(2)"/>
              <label for="2choices1">Element 1</label>
              <input type="checkbox" id="2choices2" name="2choices" onchange="checkBox(2)"/>
              <label for="2choices2">Element 2</label>
              <input type="checkbox" id="2choices3" name="2choices" onchange="checkBox(2)"/>
              <label for="2choices3">Element 3</label>
          </div>
          <div>
              <label for="pet-select">Choisir un animal:</label>
              <select name="pets" id="pet-select" onchange="checkRadio()" required>
                  <option value="">--Please choose an option--</option>
                  <option value="dog">Dog</option>
                  <option value="cat">Cat</option>
                  <option value="hamster">Hamster</option>
                  <option value="parrot">Parrot</option>
                  <option value="spider">Spider</option>
                  <option value="goldfish">Goldfish</option>
              </select>
           </div>
           <div>
          <label for="start">Choisir une date après la date actuel:</label>
           <input type="date" id="start" name="trip-start" onchange="checkDate()" required/>
           <div class="errorMessage"></div>
           </div>
           <div>
              <label for="volume">Volume</label>
              <input type="range" id="volume" name="volume" onchange="checkRange(50)" required/>
              <div class="errorMessage"></div>
            </div>
          <input type="button" value="Passer à l'étape suivante" class="buttonStep" onclick="nextStep()" disabled/>
      </fieldset>
      <fieldset class="form-group closed">
          <legend>Informations personnelles</legend>
          <div>
              <label for="lambda">Champ optionnel </label> :
              <input type="text" id="lambda" oninput="checkInput(regexOptionnalMandatoryOnLine)" />
              <div class="errorMessage"></div>
          </div>

          <div>
              <label for="textarea"> Textarea </label> :
              <textarea type="text" id="textarea" oninput="checkInput(regexOptionnalMandatoryOnLine)" required>Texte d'exemple</textarea>
              <div class="errorMessage"></div>
          </div>
          <div>
              <label for="name">Nom (no length)</label>* :
              <input type="text" id="name" required oninput="checkInput(regexName)" />
              <div class="errorMessage"></div>
          </div>
          <div>
              <label for="codePost">Code postal français (length mandatory)</label>* :
              <input type="text" id="codePost" required oninput="checkInput(regexNumber,messageFormatPostCode,'',5,'')" />
              <div class="errorMessage"></div>
          </div>
          <div>
              <label for="password">Mot de passe (length min)</label>* :
              <input type="password" id="password" required oninput="checkInput(regexPassword,messageFormatPassword,6,'','')" />
              <div class="errorMessage"></div>
          </div>

          <div>
              <label for="phone">téléphone (length max)</label>* :
              <input type="text" id="phone" required oninput="checkInput(regexPhoneInternationalAndFrench,messageFormatPhone,'','','15')" />
              <div class="errorMessage"></div>
          </div>
              <input type="button" value="Passer à l'étape suivante" class="buttonStep" onclick="nextStep()" disabled/>
      </fieldset>
</form>`}
        />
      </code>
      </pre>
      <h3>Code Javascript</h3>


      <pre>
      <code>
      <AceEditor
      height={calcHeight(298)}
      width="100%"
      fontSize={16}
      showPrintMargin={false}
      showGutter={true}
      mode="javascript"
      theme="monokai"
      value={`//////////// Les messages d'information ou d'erreurs
      const checkedMandatody = "Merci de sélectionner un des élements"
      const messageFormatPostCode = "Merci de saisir votre code postal avec ce format : 77160"
      const messageFormatPhone = "Merci de saisir un nombre de 10 numéros"
      const messageFormatPassword = "Merci de saisir un mot de passe de plus de 6 caractères"

      ///////////// Liste des regex utilisés
      const regexName = /^(\s)*[A-Za-z]+((\s)?((\'|\-|\.)?([A-Za-z])+))*(\s)*$/
      const regexEmail = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      const regexPhone = /^[0]+[1-9]{0,9}$/ // internationnal ou francais
      const regexPhoneInternationalAndFrench = /(^(\+\d{0,15})$)|(^[0]+[1-9]{0,9}$)/
      const regexPassword = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{6,}$/
      const regexNumber = /^\d+$/
      const regexEmpty = /^$/
      const regexFormatString = /^[a-z]*$/gi
      const regexOptionnalMandatoryOnLine = /^[^<>{}]*$/
      
      ///////////// Construction des alertes de vérifications
      function errorEmptyMessage(labelValue,errorMessage,parentElement){
          const message = "Le champ " + labelValue + " est vide, merci de le renseigner"
          errorMessage.textContent = message
          parentElement.classList.add('js-error')
          parentElement.classList.remove('js-valid')
          parentElement.classList.remove('js-info')
          checkByStep(this)
      }
      function errorFormatMessage(labelValue,errorMessage,parentElement){
          const message = "Le format du champ " + labelValue + " est invalide, merci de corriger"
          errorMessage.textContent = message
          parentElement.classList.add('js-error')
          parentElement.classList.remove('js-valid')
          parentElement.classList.remove('js-info')
          checkByStep(this)
      }
      function infoFormatMessage(labelValue,errorMessage,parentElement,maxValue,messageInfo){
          errorMessage.textContent = messageInfo
          parentElement.classList.add('js-info')
          parentElement.classList.add('js-error')
          parentElement.classList.remove('js-valid')
          checkByStep(this)
      }
      function infoFormatMessageMin(labelValue,errorMessage,parentElement,minValue,messageInfo){
          errorMessage.textContent = messageInfo
          parentElement.classList.add('js-info')
          parentElement.classList.add('js-error')
          parentElement.classList.remove('js-valid')
          checkByStep(this)
      }
      function infoFormatMessageMax(labelValue,errorMessage,parentElement,minValue,messageInfo){
          errorMessage.textContent = messageInfo
          parentElement.classList.add('js-info')
          parentElement.classList.add('js-error')
          parentElement.classList.remove('js-valid')
          checkByStep(this)
      }
      function validFormatMessage(errorMessage,parentElement){
          errorMessage.textContent = ""
          parentElement.classList.add('js-valid')
          parentElement.classList.remove('js-error')
          parentElement.classList.remove('js-info')
          checkByStep(this)
      }

      ///////////// fonction de vérification des input txt,psw,textarea
      function checkInput(regex,messageInfo,minLength,lengthMandatory,maxLenght){
          // Param regex = Ajouter la regex à utiliser
          // Param messageInfo = Choisir le message d'information à afficher
          // Param minLenght = Ajouter une longeur minimum (optionnel)
          // Param lengthMandatory = Ajouter une longueur obligatoire (optionnel)
          // Param maxLenght = Ajouter une longeur maximum (optionnel)
          const inputMandatory = event.target.hasAttribute("required")
          let errorMessage = event.target.nextElementSibling
          let parentElement = event.target.parentElement
          const inputValue = event.target.value;
          const labelValue = event.target.previousElementSibling.textContent.toLowerCase()
          if(inputMandatory==true && lengthMandatory){ 
              // Si champ obligatoire et si une longeur obligatoire est renseignée
              switch (true) {
              case regexEmpty.test(inputValue):
              errorEmptyMessage(labelValue,errorMessage,parentElement)
              break;
              case !regex.test(inputValue):
              errorFormatMessage(labelValue,errorMessage,parentElement)
              break;
              case inputValue.length < lengthMandatory:
              infoFormatMessage(labelValue,errorMessage,parentElement,lengthMandatory,messageInfo)
              break;
              case inputValue.length > lengthMandatory:
              errorFormatMessage(labelValue,errorMessage,parentElement)
              break;
              default:
              validFormatMessage(errorMessage,parentElement)
              }
      }else if(inputMandatory==true && minLength){
           // Si champ obligatoire et Si une longeur min est renseignée
          switch (true) {
              case regexEmpty.test(inputValue):
              errorEmptyMessage(labelValue,errorMessage,parentElement)
              break;
              case (inputValue.length < minLength):
              infoFormatMessage(labelValue,errorMessage,parentElement,lengthMandatory,messageInfo)
              break;
              case inputValue.length >= minLength && regex.test(inputValue) :
              validFormatMessage(errorMessage,parentElement)
              break;
              default:
              errorFormatMessage(labelValue,errorMessage,parentElement)
              }
      }else if(maxLenght){
          // Si champ obligatoire et Si une longeur maximum est renseignée
          switch (true) {
              case regexEmpty.test(inputValue):
              errorEmptyMessage(labelValue,errorMessage,parentElement)
              break;
              case (inputValue.length > maxLenght):
              errorFormatMessage(labelValue,errorMessage,parentElement)
              break;
              case inputValue.length <= maxLenght && regex.test(inputValue) :
              validFormatMessage(errorMessage,parentElement)
              break;
              default:
              errorFormatMessage(labelValue,errorMessage,parentElement)
              }
      }else if(inputMandatory==true && (!lengthMandatory || !minLength || !maxLenght)){ 
          // Si champ obligatoire et Si il n'y a aucun paramètre de longueur obligatoire
          switch (true) {
              case regexEmpty.test(inputValue):
              errorEmptyMessage(labelValue,errorMessage,parentElement)
              break;
              case regex.test(inputValue):
              validFormatMessage(errorMessage,parentElement)
              break
              default:
              errorFormatMessage(labelValue,errorMessage,parentElement)
              }
          }else if(inputMandatory==false){
              // Si champ c'est un champs optionnel
              switch (true) {
              case regex.test(inputValue):
              validFormatMessage(errorMessage,parentElement)
              break
              default:
              errorFormatMessage(labelValue,errorMessage,parentElement)
              }
          }
      }
      ////////// VERIFICATION CHECK RANGE
      function checkRange(minValue){
          let parentElement = event.target.parentElement
          let errorMessage = event.target.nextElementSibling
          let rangeValue = this.event.target.value
          if(rangeValue < minValue){
              errorMessage.textContent = "Merci de selectionner une date supérieur à la date actuelle"
              parentElement.classList.remove("js-valid")
              parentElement.classList.add('js-error')
              checkByStep(this)
          }else{
              errorMessage.textContent =""
              parentElement.classList.add("js-valid")
              parentElement.classList.remove('js-error')
              checkByStep(this)
          }

      }
      ////////// VERIFICATION DES BOUTONS RADIO
      function checkRadio() {
          let parentElement = event.target.parentElement
          parentElement.classList.add("js-valid")
          checkByStep(this)
      }
      ////////// VERIFICATION DES DATE
      function checkDate() {
          let dateValue = this.event.target.value
          let dateChoose = new Date(dateValue)
          var currentDate = new Date();
         /* var y = currentDate.getFullYear();
          var m = currentDate.getMonth();
          var d = currentDate.getDate();
          var currentDateok = new Date(y,m,d);*/
          var getTimeCurrent = currentDate.getTime();
          var getTimeChoose = dateChoose.getTime();
          console.log(getTimeCurrent)
          console.log(getTimeChoose)
          let parentElement = event.target.parentElement
          let errorMessage = event.target.nextElementSibling
          if(getTimeCurrent >= getTimeChoose){
              errorMessage.textContent = "Merci de selectionner une date supérieur à la date actuelle"
              parentElement.classList.remove("js-valid")
              parentElement.classList.add('js-error')
              checkByStep(this)
          }else{
              errorMessage.textContent = ""
              parentElement.classList.add("js-valid")
              parentElement.classList.remove('js-error')
              checkByStep(this)
          }

      }
      ////////// VERIFICATION DES CHECKBOX
      function checkBox(numberMandatory){
          let parentElement = event.target.parentElement
          if(!numberMandatory){
              if(this.event.target.checked){
              parentElement.classList.add("js-valid")
              parentElement.classList.remove('js-error')
              checkByStep(this)
              }else{
              parentElement.classList.remove("js-valid")
              parentElement.classList.add('js-error')
              checkByStep(this)
              }
           }
           if(numberMandatory){
              let allCheckbox = parentElement.querySelectorAll('input[type="checkbox"]').length
              let allCheckboxChecked = parentElement.querySelectorAll('input[type="checkbox"]:checked').length
              if(allCheckboxChecked < numberMandatory){
                  parentElement.classList.remove("js-valid")
                  parentElement.classList.add('js-error')
                  checkByStep(this)
              }else{
                  parentElement.classList.add("js-valid")
                  parentElement.classList.remove('js-error')
                  checkByStep(this)
              }
/*
              if(nbOfElementChecked==numberMandatory){
                  parentElement.classList.add("js-valid")
                  parentElement.classList.remove('js-error')
                  checkByStep(this)
              }else{
                  parentElement.classList.remove("js-valid")
                  parentElement.classList.add('js-error')
                  checkByStep(this)
              }*/
              
           }
           
      }
      /////////// Liste des champs obligatoire et ajout de la class js-mandatory
      let mandatoryElement = document.querySelectorAll("form input:required,form select:required,form textarea:required")
      // Passer sur tous les élements obligatoires
      for (let i = 0; i < mandatoryElement.length; i++) {
          let parentElement = mandatoryElement[i].parentElement
          parentElement.classList.add("js-mandatory")
      }
      ////////// FONCTION CHECK ALL INPUT BY STEP
      function checkByStep(element) {
          let grandParentElement = element.event.target.parentElement.parentElement
          let childGrandParent = grandParentElement.querySelectorAll('.js-mandatory')
          let buttonStep = grandParentElement.querySelector('.buttonStep')
          // variable de récupération du nombre d'élément valid dans les mandatory
          let elementValid = 0
          // variable de récupération du nombre d'élément error dans les mandatory
          let elementError = 0
          let elementInfo = 0
          for (let i = 0; i < childGrandParent.length; i++) {
              // Incrément des éléments valid
              if (childGrandParent[i].classList.contains('js-valid')) {
                  elementValid++
              }
              // Incrément des éléments valid
              if (childGrandParent[i].classList.contains('js-error')) {
                  elementError++
              }
              // Incrément des éléments saisie wait
              if (childGrandParent[i].classList.contains('js-info')) {
                  elementInfo++
              }
          }
          if (elementValid === childGrandParent.length) {
              grandParentElement.classList.add('js-valid')
              grandParentElement.classList.remove('js-error')
              // Supprimer l'attribut disabled pour l'activer
              buttonStep.removeAttribute('disabled')
          }
          if (elementError > 0) {
              grandParentElement.classList.remove('js-valid')
              grandParentElement.classList.add('js-error')
              buttonStep.setAttribute('disabled',"")
          }
          if (elementInfo > 0) {
              grandParentElement.classList.remove('js-valid')
              grandParentElement.classList.add('js-info')
              buttonStep.setAttribute('disabled',"")
          }else{grandParentElement.classList.remove('js-info')}
      }
      ////////// FONCTION BUTTON OPEN THE NEXT ELEMENT
      function nextStep(){
          let element = this.event.target
          // Selection de l'élément suivant
          let nextStep = element.parentElement.nextElementSibling
          // Si l'élement suivant contient la classe closed
          if (nextStep.classList.contains("closed")) {
              nextStep.classList.replace('closed', 'opened')
          }
      }
      `}

        /></code></pre>



      </div>
    )
    
}
